import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { fetchItemsFromCategoriesDataClear } from '../actions/items';

import { formatCategoryName } from '../scripts/functions';

// import './styling/PreviousBar.css';

export default function PreviousBar(props) {
    const { previous, isShortened, brand } = props;

    const dispatch = useDispatch();

    if (brand) {
        return (
            <div className="previous-bar-container">
                <ul className="previous-bar">
                    <Link to="/">
                        <li className="previous-bar-item hide-mobile">
                            <span className="previous-bar-link">Home</span>
                        </li>
                    </Link>
                    <li className="previous-bar-item hide-mobile">
                        <span>&nbsp;</span>
                        <i className="fas fa-angle-double-right" />
                        <span className="previous-bar-link">{` ${brand}`}</span>
                    </li>
                </ul>
            </div>
        );
    }

    const renderRemaining = () => {
        if (isShortened) {
            const category = previous[previous.length - 1];
            const { name } = category || {};

            return (
                <Link
                    to={`/category/${formatCategoryName(name || '')}`}
                    onClick={() => {
                        dispatch(fetchItemsFromCategoriesDataClear());
                    }}
                >
                    <li className="previous-bar-item hide-mobile">
                        <span>&nbsp;</span>
                        <i className="fas fa-angle-double-right" />
                        <span className="previous-bar-link">{` ${
                            name || ''
                        }`}</span>
                    </li>
                </Link>
            );
        }

        return previous.map((category) => {
            const { name, id } = category || {};

            return (
                <Link
                    to={`/category/${formatCategoryName(name || '')}`}
                    key={`previous-bar-item-${id || ''}`}
                    onClick={() => {
                        dispatch(fetchItemsFromCategoriesDataClear());
                    }}
                >
                    <li className="previous-bar-item hide-mobile">
                        <span>&nbsp;</span>
                        <i className="fas fa-angle-right" />
                        <span className="previous-bar-link">{` ${
                            name || ''
                        }`}</span>
                    </li>
                </Link>
            );
        });
    };

    return (
        <div className="previous-bar-container">
            <ul className="previous-bar">
                <Link to="/all-products">
                    <li className="previous-bar-item hide-mobile">
                        <span className="previous-bar-link">All Products</span>
                    </li>
                </Link>
                {previous.length ? renderRemaining() : ''}
            </ul>
        </div>
    );
}
